module.exports = __webpack_public_path__ + "img/172.e87eff7b.jpg";